/* CUSTOM JS */
console.log('twentyfourcustomcode.js loaded');

/* KLAVIYO REVIEWS */

document.addEventListener('DOMContentLoaded', function () {
  function initKlaviyoReviews() {
    if (window.klaviyoReviews) {
      window.klaviyoReviews.loadWidgets();
    }
  }

  initKlaviyoReviews();

  document.addEventListener('shopify:section:load', function () {
    initKlaviyoReviews();
  });
});

/* MAIN PRODUCT GALLERY ARROWS */

document.addEventListener('DOMContentLoaded', initTwentyFourGalleryArrows);
document.addEventListener('shopify:section:load', initTwentyFourGalleryArrows);

function initTwentyFourGalleryArrows() {
  const productMediaWrappers = document.querySelectorAll('.product__media-list-wrapper');

  productMediaWrappers.forEach((wrapper) => {
    if (wrapper.dataset.tfArrowsInit === 'true') return;

    const swiperEl =
      wrapper.querySelector('.product__media-list.swiper') ||
      wrapper.querySelector('.swiper');

    if (!swiperEl || !swiperEl.swiper) return;

    const existingNav = wrapper.querySelector('.tf-gallery-nav');
    if (existingNav) existingNav.remove();

    const nav = document.createElement('div');
    nav.className = 'tf-gallery-nav';

    const prevBtn = document.createElement('button');
    prevBtn.className = 'tf-gallery-arrow tf-gallery-prev';
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous image');

    const nextBtn = document.createElement('button');
    nextBtn.className = 'tf-gallery-arrow tf-gallery-next';
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next image');

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);
    wrapper.appendChild(nav);

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      swiperEl.swiper.slidePrev();
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      swiperEl.swiper.slideNext();
    });

    wrapper.dataset.tfArrowsInit = 'true';
  });
}

/* PRODUCT CARD IMAGE SLIDER
   Adds a real image slider to product cards: arrows on desktop, finger-tracking
   swipe on touch. Runs only when the theme setting
   Product cards > Hover effect is set to "Image arrows" (a custom option added
   to config/settings_schema.json). Keeping it as its own mode means it never
   competes with the "Show second image" hover effect for the same image slot.

   Design notes, each written after the earlier attempt felt wrong:
   - Nothing waits on a network round trip. The image list is fetched and the
     track is built as the card nears the viewport, so the first gesture moves
     straight away instead of stalling.
   - Slides live in a flex track that follows the finger and eases on release,
     rather than an <img> src being swapped at the end of the gesture.
   - The track carries a clone of the last image before the first and a clone
     of the first after the last. Passing either end therefore keeps travelling
     one slide in the direction of travel, and the track is silently repositioned
     onto the real slide once the animation finishes. Without those clones the
     wrap rewound across every slide instead of completing the cycle. */

(function () {
  var CACHE = {};                // handle -> array of image urls
  var PENDING = {};              // handle -> promise
  var STATE = new WeakMap();     // card -> slider state
  var ARROWS_MODE = 'product-card__media--hover-effect-image_arrows';
  var SWIPE_RATIO = 0.15;        // fraction of card width that commits a swipe
  var SWIPE_MIN = 30;            // ...with a floor in px for narrow cards
  var ANIM_MS = 320;             // keep in step with .tf-card-anim in the CSS

  function widthUrl(url, w) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', w);
      return u.href;
    } catch (e) {
      return url;
    }
  }

  function buildSrcset(url) {
    return [360, 535, 720, 940, 1200, 1600, 2000]
      .map(function (w) { return widthUrl(url, w) + ' ' + w + 'w'; })
      .join(', ');
  }

  function loadImages(handle) {
    if (CACHE[handle]) return Promise.resolve(CACHE[handle]);
    if (PENDING[handle]) return PENDING[handle];

    PENDING[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        CACHE[handle] = (data && data.images) || [];
        delete PENDING[handle];
        return CACHE[handle];
      })
      .catch(function () {
        CACHE[handle] = [];
        delete PENDING[handle];
        return [];
      });

    return PENDING[handle];
  }

  function setImg(node, url) {
    if (!node || !url || node.dataset.tfLoaded === 'true') return;
    node.setAttribute('src', widthUrl(url, 1200));
    node.setAttribute('srcset', buildSrcset(url));
    node.dataset.tfLoaded = 'true';
  }

  /* Only give a slide a real src when it is on screen or next to it, so a grid
     of cards does not pull down every image of every product. The clones mirror
     the first and last images, so they load with them. */
  function ensureLoaded(state, i) {
    var count = state.slides.length;
    setImg(state.slides[i], state.urls[i]);
    if (i === 0) setImg(state.cloneFirst, state.urls[0]);
    if (i === count - 1) setImg(state.cloneLast, state.urls[count - 1]);
  }

  function slideWidth(state) {
    return state.track.getBoundingClientRect().width || 1;
  }

  /* pos counts track children, so it is one ahead of the image index: the
     leading clone sits at 0 and real image i sits at i + 1. */
  function place(state, pos, dx, animate) {
    state.track.classList.toggle('tf-card-anim', !!animate);
    if (!animate) {
      // Flush the class change so a following animated move is not batched
      // into this one and skipped.
      void state.track.offsetWidth;
    }
    state.track.style.transform =
      'translate3d(' + (-(pos * slideWidth(state)) + (dx || 0)) + 'px, 0, 0)';
  }

  function afterTransition(state, fn) {
    var done = false;
    function finish(e) {
      if (e && e.target !== state.track) return;
      if (done) return;
      done = true;
      state.track.removeEventListener('transitionend', finish);
      fn();
    }
    state.track.addEventListener('transitionend', finish);
    // Belt and braces: transitionend does not fire if the move is a no-op.
    setTimeout(function () { finish(); }, ANIM_MS + 80);
  }

  function goTo(card, target) {
    var state = STATE.get(card);
    if (!state) return;
    var count = state.slides.length;
    if (count < 2) return;

    var i = ((target % count) + count) % count;
    var current = state.index;
    var pos;

    if (target >= count && current === count - 1) {
      pos = count + 1;        // forward off the end, onto the clone of image 1
    } else if (target < 0 && current === 0) {
      pos = 0;                // backward off the start, onto the clone of the last
    } else {
      pos = i + 1;
    }

    state.index = i;
    card.dataset.tfCardIndex = String(i);

    ensureLoaded(state, i);
    ensureLoaded(state, (i + 1) % count);
    ensureLoaded(state, (i - 1 + count) % count);

    state.pos = pos;
    place(state, pos, 0, true);

    if (pos === 0 || pos === count + 1) {
      // The shopper is looking at a clone; once it settles, swap to the real
      // slide with no transition so the next move continues cleanly.
      afterTransition(state, function () {
        state.pos = i + 1;
        place(state, state.pos, 0, false);
      });
    }
  }

  function buildTrack(card) {
    var media = card.querySelector('.product-card__media');
    var first = card.querySelector('.media--first');
    if (!media || !first || STATE.has(card)) return Promise.resolve(null);

    return loadImages(card.dataset.product).then(function (urls) {
      // Nothing to page through, so leave the card as the theme built it.
      if (!urls || urls.length < 2 || STATE.has(card)) return null;

      var track = document.createElement('div');
      track.className = 'tf-card-track';

      function blankClone() {
        var c = first.cloneNode(false);
        c.removeAttribute('src');
        c.removeAttribute('srcset');
        c.removeAttribute('id');
        c.removeAttribute('data-tf-loaded');
        c.setAttribute('loading', 'lazy');
        c.setAttribute('aria-hidden', 'true');
        return c;
      }

      media.insertBefore(track, media.firstChild);

      // Leading clone of the last image.
      var cloneLast = blankClone();
      track.appendChild(cloneLast);

      // Reuse the theme's own <img> as image 1 so its sizing, alt text and
      // object-fit carry over unchanged, then clone it for the rest.
      var slides = [first];
      first.dataset.tfLoaded = 'true';
      track.appendChild(first);

      for (var i = 1; i < urls.length; i++) {
        var clone = blankClone();
        clone.removeAttribute('aria-hidden');
        track.appendChild(clone);
        slides.push(clone);
      }

      // Trailing clone of the first image.
      var cloneFirst = blankClone();
      track.appendChild(cloneFirst);

      var state = {
        track: track,
        slides: slides,
        urls: urls,
        cloneFirst: cloneFirst,
        cloneLast: cloneLast,
        index: 0,
        pos: 1
      };
      STATE.set(card, state);

      place(state, 1, 0, false);
      ensureLoaded(state, 0);
      ensureLoaded(state, 1);
      ensureLoaded(state, urls.length - 1);

      addArrows(card, media);
      addSwipe(card, state);
      return state;
    });
  }

  function addArrows(card, media) {
    if (card.dataset.tfCardArrows === 'true') return;
    var nav = document.createElement('div');
    nav.className = 'tf-card-nav';

    ['prev', 'next'].forEach(function (dir) {
      var btn = document.createElement('button');
      btn.className = 'tf-card-arrow tf-card-' + dir;
      btn.type = 'button';
      btn.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      btn.addEventListener('click', function (e) {
        // The card is wrapped in a link overlay; stop this becoming a visit
        // to the product page.
        e.preventDefault();
        e.stopPropagation();
        var state = STATE.get(card);
        if (state) goTo(card, state.index + (dir === 'prev' ? -1 : 1));
      });
      nav.appendChild(btn);
    });

    media.appendChild(nav);
    card.dataset.tfCardArrows = 'true';
  }

  function addSwipe(card, state) {
    var startX = 0, startY = 0, dx = 0;
    var dragging = false, decided = false, swiped = false;

    // Bound to the card rather than the media element: the link overlay is
    // stacked on top, so a real finger never touches the media directly.
    card.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || state.slides.length < 2) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      dragging = true;
      decided = false;
      swiped = false;
      state.track.classList.remove('tf-card-anim');
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (!dragging || e.touches.length !== 1) return;
      var mx = e.touches[0].clientX - startX;
      var my = e.touches[0].clientY - startY;

      if (!decided) {
        // Let the page scroll if the gesture is mostly vertical.
        if (Math.abs(my) > Math.abs(mx)) { dragging = false; return; }
        if (Math.abs(mx) < 6) return;
        decided = true;
      }

      // Now this is a horizontal drag, stop the page scrolling under it.
      if (e.cancelable) e.preventDefault();
      dx = mx;
      swiped = true;
      place(state, state.pos, dx, false);
    }, { passive: false });

    function finish() {
      if (!dragging) return;
      dragging = false;
      var threshold = Math.max(SWIPE_MIN, slideWidth(state) * SWIPE_RATIO);
      if (Math.abs(dx) > threshold) {
        goTo(card, state.index + (dx < 0 ? 1 : -1));
      } else {
        place(state, state.pos, 0, true);
      }
      dx = 0;
    }

    card.addEventListener('touchend', finish, { passive: true });
    card.addEventListener('touchcancel', finish, { passive: true });

    // A swipe finishes with a click landing on the link overlay; swallow it.
    card.addEventListener('click', function (e) {
      if (!swiped) return;
      swiped = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function resetCard(card) {
    var state = STATE.get(card);
    if (!state || state.index === 0) return;
    // Instant, not animated: the pointer has already gone, and rewinding
    // across every slide is exactly the motion this design avoids.
    state.index = 0;
    state.pos = 1;
    card.dataset.tfCardIndex = '0';
    place(state, 1, 0, false);
  }

  function initCard(card) {
    if (card.dataset.tfCardInit === 'true') return;
    var media = card.querySelector('.product-card__media');
    if (!media || !media.classList.contains(ARROWS_MODE)) return;
    if (!card.querySelector('.media--first')) return; // placeholder card
    card.dataset.tfCardInit = 'true';

    // Build ahead of the shopper reaching the card so the first gesture moves
    // immediately instead of waiting on the products fetch.
    buildTrack(card);

    // Moving off the card returns it to the featured image. Swapping slides can
    // make the browser fire a stray pointerleave, so confirm the cursor really
    // has gone before resetting.
    card.addEventListener('pointerleave', function (e) {
      if (card.matches(':hover')) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      resetCard(card);
    });
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              initCard(entry.target);
            });
          },
          { rootMargin: '300px' }
        )
      : null;

  function watch(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('product-card').forEach(function (card) {
      if (observer) observer.observe(card);
      else initCard(card);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { watch(); });
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });

  // Filtering, sorting and load-more swap the grid markup out.
  var queued = false;
  new MutationObserver(function (mutations) {
    var hasCards = mutations.some(function (m) {
      return [].some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 &&
          (n.tagName === 'PRODUCT-CARD' || (n.querySelector && n.querySelector('product-card')));
      });
    });
    if (!hasCards || queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; watch(); });
  }).observe(document.body, { childList: true, subtree: true });

  // Offsets are measured in px, so re-place after the card width changes.
  var rt;
  var cardViewportWidth = document.documentElement.clientWidth;
  window.addEventListener('resize', function () {
    // Mobile browser bars change height during scroll, not the card widths.
    var nextWidth = document.documentElement.clientWidth;
    if (nextWidth === cardViewportWidth) return;
    cardViewportWidth = nextWidth;
    clearTimeout(rt);
    rt = setTimeout(function () {
      document.querySelectorAll('product-card').forEach(function (card) {
        var state = STATE.get(card);
        if (state) place(state, state.pos, 0, false);
      });
    }, 150);
  });
})();

/* ============================================================
   CRO / PERFORMANCE PASS (added 2026-09-09)
   ============================================================ */

/* BELOW-FOLD VIDEO LAZY LOAD
   Defer decorative video sources until visible, then keep observing so they
   resume after scrolling back, returning to the tab, or a playback-blocking
   browser policy. The inline theme.liquid script detaches sources early;
   this manager restores them and respects reduced-motion preferences. */
(function () {
  var ROOT_MARGIN = '200px 0px';
  var tracked = new Set();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function nearFold(video) {
    var rect = video.getBoundingClientRect();
    var vh = window.innerHeight || 800;
    return rect.bottom > -200 && rect.top < vh * 1.25;
  }

  function detach(video) {
    var sources = [];
    video.querySelectorAll('source').forEach(function (source) {
      sources.push({ src: source.getAttribute('src'), type: source.getAttribute('type') });
      source.parentNode.removeChild(source);
    });
    var direct = video.getAttribute('src');
    if (direct) {
      sources.push({ src: direct, type: null, direct: true });
      video.removeAttribute('src');
    }
    if (!sources.length) return false;
    video.__tfSources = sources;
    video.setAttribute('preload', 'none');
    try {
      video.pause();
      video.load(); // aborts the in-flight download
    } catch (e) {}
    video.dataset.tfVideoDeferred = 'true';
    return true;
  }

  function playVisible(video) {
    if (!video.isConnected || !video.__tfPlaybackStarted || document.hidden || reduced.matches) {
      video.pause();
      return;
    }
    if (!video.paused || video.__tfSources) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    var result = video.play();
    if (result && result.catch) result.catch(function () {});
  }

  function restore(video) {
    var sources = video.__tfSources;
    if (!sources) return;
    delete video.__tfSources;
    sources.forEach(function (s) {
      if (s.direct) {
        video.setAttribute('src', s.src);
        return;
      }
      var el = document.createElement('source');
      el.setAttribute('src', s.src);
      if (s.type) el.setAttribute('type', s.type);
      video.appendChild(el);
    });
    video.setAttribute('preload', 'auto');
    video.dataset.tfVideoDeferred = 'loaded';
    try {
      video.load();
      playVisible(video);
    } catch (e) {}
  }

  function init() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.__tfInView = entry.isIntersecting;
        if (entry.isIntersecting) entry.target.__tfPlaybackStarted = true;
        if (entry.isIntersecting && !reduced.matches) restore(entry.target);
        playVisible(entry.target);
      });
    }, { rootMargin: ROOT_MARGIN });

    var warmup = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !reduced.matches) restore(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    var viewport = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) playVisible(entry.target);
      });
    });

    document.querySelectorAll('video[autoplay]').forEach(function (video) {
      if (video.closest('tf-hero-banners') || video.hasAttribute('data-tf-responsive-video') || video.controls) return;
      if (video.dataset.tfVideoObserved === 'true') return;
      video.dataset.tfVideoObserved = 'true';
      tracked.add(video);
      if (!video.__tfSources && !nearFold(video)) detach(video);
      video.addEventListener('canplay', function () { playVisible(video); });
      warmup.observe(video);
      io.observe(video);
      viewport.observe(video);
    });
  }

  function resumeVisible() {
    tracked.forEach(function (video) {
      if (!video.isConnected) { tracked.delete(video); return; }
      if (video.__tfInView && !reduced.matches) restore(video);
      playVisible(video);
    });
  }
  document.addEventListener('visibilitychange', resumeVisible);
  document.addEventListener('touchend', resumeVisible, { passive: true });
  document.addEventListener('click', resumeVisible);
  window.addEventListener('pageshow', resumeVisible);
  window.addEventListener('online', resumeVisible);
  reduced.addEventListener('change', resumeVisible);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* SOLD-OUT PRODUCT FORM
   Toggles .tf-sold-out on <product-form> whenever the selected variant is
   unavailable (button disabled and labelled Sold Out), so the CSS can hide the
   quantity stepper. Re-evaluated on every change to the button, which is how
   the theme reflects a variant switch. */
(function () {
  function sync(form) {
    var btn = form.querySelector('.product-form__submit');
    if (!btn) return;
    var soldOut = btn.disabled && /sold out/i.test(btn.textContent);
    form.classList.toggle('tf-sold-out', soldOut);
  }

  function watch(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('product-form').forEach(function (form) {
      if (form.dataset.tfSoldOutWatch === 'true') return;
      form.dataset.tfSoldOutWatch = 'true';
      sync(form);
      var btn = form.querySelector('.product-form__submit');
      if (!btn) return;
      new MutationObserver(function () { sync(form); }).observe(btn, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); });
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
})();

/* FREE-SHIPPING BAR: FIXED PRESENTMENT THRESHOLD (added 2026-09-10)
   snippets/cart-shipping-slider.liquid sets data-min-spend-fixed (in the
   shopper's currency, cents) for markets whose free-shipping rule is written
   in that currency, currently New Zealand at 150 NZD. The theme's cart.js
   multiplies data-min-spend by Shopify.currency.rate, so this divides the
   fixed value by the rate first and re-runs the theme's own bar init. Bars are
   re-rendered from Liquid after every cart change, so a mutation observer
   re-applies it. */
(function () {
  function apply() {
    var bars = document.querySelectorAll('.cart-shipping[data-min-spend-fixed]');
    if (!bars.length) return;
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var changed = false;
    bars.forEach(function (bar) {
      var fixed = parseFloat(bar.dataset.minSpendFixed);
      if (!(fixed > 0)) return;
      var want = (fixed / rate).toFixed(4);
      if (bar.dataset.minSpend !== want) {
        bar.dataset.minSpend = want;
        changed = true;
      }
    });
    if (!changed) return;
    var host = document.querySelector('cart-drawer-items, cart-items');
    if (host && typeof host.initCartShipping === 'function') host.initCartShipping();
  }

  var t;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(apply, 80);
  }

  function init() {
    apply();
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes' && r.attributeName === 'data-min-spend') continue;
        schedule();
        return;
      }
    });
    document.querySelectorAll('cart-drawer, cart-items').forEach(function (host) {
      observer.observe(host, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* TWENTYFOUR CRO 2026-09-14: one responsive slideshow video per slide.
   Requires snippets/tf-responsive-slideshow-video.liquid. Sources are absent
   from HTML src attributes until the active slide approaches the viewport. */
(function () {
  var mobile = window.matchMedia('(max-width: 575px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var states = new Set();
  function sync(state) {
    var video = state.video;
    if (!video.isConnected) return;
    var slide = video.closest('.swiper-slide');
    var slider = video.closest('.swiper');
    var active = !slider || !slider.classList.contains('swiper-initialized') ||
      !slide || slide.classList.contains('swiper-slide-active');
    if (state.near) state.started = true;
    if (reducedMotion.matches || !state.started || !active || document.hidden) {
      video.pause();
      if (reducedMotion.matches) {
        video.parentElement.classList.remove('is-playing');
        if (video.hasAttribute('src')) { video.removeAttribute('src'); video.load(); }
      }
      return;
    }
    var source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    var poster = mobile.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
    if (!source) return;
    if (video.getAttribute('src') !== source) {
      video.parentElement.classList.remove('is-playing');
      video.poster = poster;
      video.muted = true;
      video.src = source;
      video.load();
    }
    if (!video.paused) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    var play = video.play();
    if (play && play.catch) play.catch(function () { /* Keep the poster if autoplay is unavailable. */ });
  }
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      states.forEach(function (state) {
        if (state.video === entry.target) { state.near = entry.isIntersecting; sync(state); }
      });
    });
  }, { rootMargin: '200px 0px' }) : null;
  var viewportObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) states.forEach(function (state) { if (state.video === entry.target) sync(state); });
    });
  }) : null;
  function init() {
    document.querySelectorAll('video[data-tf-responsive-video]').forEach(function (video) {
      if (video.dataset.tfResponsiveReady) return;
      video.dataset.tfResponsiveReady = 'true';
      var state = { video: video, near: !observer };
      states.add(state);
      video.addEventListener('playing', function () { video.parentElement.classList.add('is-playing'); });
      var slide = video.closest('.swiper-slide');
      if (slide) {
        state.slideObserver = new MutationObserver(function () { sync(state); });
        state.slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
      }
      if (viewportObserver) viewportObserver.observe(video);
      if (observer) observer.observe(video);
      else sync(state);
    });
  }
  function syncAll() { states.forEach(sync); }
  window.addEventListener('pageshow', syncAll);
  window.addEventListener('online', syncAll);
  document.addEventListener('touchend', syncAll, { passive: true });
  document.addEventListener('click', syncAll);
  mobile.addEventListener('change', syncAll);
  reducedMotion.addEventListener('change', syncAll);
  document.addEventListener('visibilitychange', syncAll);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    states.forEach(function (state) {
      if (!event.target.contains(state.video)) return;
      state.video.pause();
      if (observer) observer.unobserve(state.video);
      if (viewportObserver) viewportObserver.unobserve(state.video);
      if (state.slideObserver) state.slideObserver.disconnect();
      states.delete(state);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
